
(function ($) {
  Drupal.behaviors.mpp_v1 = {
    attach: function (context, settings) {
      // insert touts between the mpp product grids
      if (Drupal.settings.globals_variables && typeof Drupal.settings.globals_variables.enable_inline_tout !== 'undefined' && Drupal.settings.globals_variables.enable_inline_tout === true) {
        $(document).on('mpp-custom--tout:event', function() {
          var $products = $('li.product-brief', context);
          var $toutWrapper = $('.js-mpp_tout', context).once('js-customToutInsert');
          $toutWrapper.each(function(i) {
            var $this = $(this);
            var inlinePosition = $this.data('position') - 1;
            var $listSelector, $tout;
            //Check whether content block exists
            if (($this.find('.js-product-grid__tout').length > 0) && !isNaN(inlinePosition)) {
              $tout = $('<li/>').attr({
                'class': 'product-brief product-brief-tout js-product-brief-tout',
                'data-position': inlinePosition,
              }).append($this.children());
              $listSelector = $products.eq(inlinePosition - i);
              $tout.insertBefore($listSelector);
            }
          });
        });
      }
      var productsData = page_data['catalog-mpp'].categories[0].products;
      site.productView.mpp.init(productsData);
      //product sort
      site.productSort.init(productsData);

      // Personalization MPP initialization
      if ( Drupal.ELB.hasPersonalization() ) {
        site.profile.mobile.MPP(page_data['catalog-mpp']);
      };
    }
  };
})(jQuery);


